import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { revokePeerSupportLeadPost } from '@/services/api/requests/peer-support';

const usePeerSupportLeadRevoke = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ organizationId, userId }: { organizationId: string; userId: string }) => {
      if (!organizationId) throw Error('No Organization ID');

      const response = await revokePeerSupportLeadPost(organizationId, userId);

      return response;
    },
    onSuccess: () => {
      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Peer Support Lead revoking successful!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          status: 'error',
          title: 'Error',
          description: 'Error while revoking Peer Support Lead privileges',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default usePeerSupportLeadRevoke;
